/* eslint-disable react-native/no-inline-styles */
import type { NavigationProp, ParamListBase } from "@react-navigation/core";
import React, { FC, useEffect } from "react";
import { Platform, StyleSheet, Text, View } from "react-native";
import { useSelector } from "react-redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import { PageContainer } from "../components";

const P00_404: FC<{ navigation: NavigationProp<ParamListBase> }> = () => {
  const isBig = useSelector((state) => state.NavigationReducer.drawerType === "permanent");

  useEffect(() => {
    if (Platform.OS !== "web") return;
    window.location.href = `${window.location.origin}/tmt-landing/404.html`;
  }, []);

  return (
    <PageContainer
      viewStyle={styles.gStackScreenDefault}
      scrollViewStyle={styles.gStackScreenDefault}
      scrollViewContainerStyle={isBig ? styles.gApplyViewView : styles.gApplyViewViewNoMargin}
    >
      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        <Text style={(kFonts.H3, { fontSize: 24 })}>404 - Not Found</Text>
      </View>
    </PageContainer>
  );
};

export const P00 = React.memo(P00_404);

const styles = StyleSheet.create({
  gApplyViewView: {
    alignItems: "stretch",
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
    marginHorizontal: 20 * kStyleConst.kSpacing,
  },
  gApplyViewViewNoMargin: {
    alignItems: "stretch",
    backgroundColor: kColors.brandLight,
    flexDirection: "column",
    flexGrow: 1,
  },
  gStackScreenDefault: {
    backgroundColor: kColors.brandLight,
    flex: 1,
  },
});
